'use client'

import { statsAgentList } from '@plugin/statistics'
import { map } from 'lodash-es'
import { useEffect } from 'react'

export default function AgentListStats({
  data
}) {

  useEffect(() => {
    const ids = map(data, 'id')
    statsAgentList(ids.join(','), 'find-agent-search-result')
  }, [data])
}
